import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/components/base/confirm-dialog/confirm-dialog.component';
import { ImageCropperDialogComponent } from 'src/app/components/base/image-cropper-dialog/image-cropper-dialog.component';
import { UpdateSelfNicknameDialogComponent } from 'src/app/components/profile/update-self-nickname-dialog/update-self-nickname-dialog.component';
import { UpdateSelfPasswordDialogComponent } from 'src/app/components/profile/update-self-password-dialog/update-self-password-dialog.component';
import { UpdateSelfPhoneDialogComponent } from 'src/app/components/profile/update-self-phone-dialog/update-self-phone-dialog.component';
import { WxloginModalComponent } from 'src/app/components/wxlogin-modal/wxlogin-modal.component';
import { FileApiService } from 'src/app/services/api/file-api.service';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-profile-info-page',
  templateUrl: './user-profile-info-page.component.html',
  styleUrls: ['./user-profile-info-page.component.scss'],
})
export class UserProfileInfoPageComponent implements OnInit, OnDestroy {
  self: any;
  selfSubscription: Subscription;
  constructor(
    private user: UserService,
    private dialog: MatDialog,
    private fileApi: FileApiService,
    private api: UserApiService,
    private message: MessageService
  ) {
    this.selfSubscription = this.user.events.subscribe((r) => {
      this.self = r;
    });
  }

  @ViewChild('fileinput') fileinput!: ElementRef;

  ngOnInit(): void {
    this.getSelf();
  }

  ngOnDestroy(): void {
    this.selfSubscription.unsubscribe();
  }

  async getSelf() {
    try {
      this.self = await this.user.getSelf();
    } catch (error) {}
  }

  onImageSelected(e: any) {
    if (e.target.files.length === 0) {
      return;
    }
    const file = e.target.files[0];
    e.target.value = '';
    this.dialog
      .open(ImageCropperDialogComponent, {
        autoFocus: false,
        panelClass: 'app-dialog',
        data: file,
      })
      .afterClosed()
      .subscribe((r) => {
        if (r) {
          this.uploadAvatar(r);
        }
      });
  }

  loading = false;
  async uploadAvatar(file: any) {
    try {
      this.loading = true;
      const r = await this.fileApi.uploadFile(file);
      const fileid = r.data.fileid;
      const rr = await this.api.updateSelfAvatar(fileid);
      if (rr.status !== 0) {
        this.message.warn('未知错误');
      } else {
        this.message.open('修改成功');
        this.self = rr.data;
        this.user.setSelf(rr.data);
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  updateNickname() {
    this.dialog.open(UpdateSelfNicknameDialogComponent, {
      autoFocus: false,
      data: this.self.nickname,
      panelClass: 'app-dialog',
    });
  }

  updatePhone() {
    this.dialog.open(UpdateSelfPhoneDialogComponent, {
      autoFocus: false,
      panelClass: 'app-dialog',
    });
  }

  updatePassword() {
    this.dialog.open(UpdateSelfPasswordDialogComponent, {
      autoFocus: false,
      panelClass: 'app-dialog',
    });
  }

  bindWechat() {
    if (!this.self?.publicid) {
      this.dialog.open(WxloginModalComponent, {
        data: 'bind',
      });
    } else {
      this.message.open('您已绑定微信，无须重复绑定');
    }
  }

  async logout() {
    this.dialog
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        data: { text: '是否确认退出登录？' },
      })
      .afterClosed()
      .subscribe(async (r) => {
        if (r) {
          await this.api.logout();
          window.location.href = '/';
        }
      });
  }
}
